import { render, staticRenderFns } from "./RedirectionError.vue?vue&type=template&id=05e63866"
import script from "./RedirectionError.vue?vue&type=script&lang=js"
export * from "./RedirectionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports